// Installer Roles
export const INSTALLER = "INSTALLER"
export const INSTALLER_ADMIN = "INSTALLER-ADMIN"
export const INSTALLER_APPROVED = "INSTALLER-APPROVED"

// UI Recognised Roles
export const CONFIG_RULE_SOLE_TRADERS_OR_APPROVED_INSTALLER_ONLY =
    "CONFIG_RULE_SOLE_TRADERS_OR_APPROVED_INSTALLER_ONLY"

// DNO Roles
export const DNO_APPROVED = "DNO-APPROVED"
export const DNO_REPORTING = "DNO-REPORTING"
export const DNO_REVIEWER = "DNO-REVIEWER"
export const DNO_ADMIN = "DNO-ADMIN"
export const DNO_THRESHOLD_MANAGER = "DNO-THRESHOLD-MANAGER"

// LCT Manufacturer Roles
export const LCT_MANU_APPROVED = "LCT-MANU-APPROVED"
export const LCT_MANU_ADMIN = "LCT-MANU-ADMIN"

// Identifier role tags
export const IDENTIFIER_ROLE_DNO_TAG = "DNO:"
export const IDENTIFIER_ROLE_INSTALLER_TAG = "INSTALLER:"
export const IDENTIFIER_ROLE_LCT_MANU_TAG = "LCT_MANU:"

// Identifier type tags
export const IDENTIFIER_TYPE_DNO_TAG = "ID:DNO:"
export const IDENTIFIER_TYPE_INSTALLER_TAG = "ID:INSTALLER:"
export const IDENTIFIER_TYPE_LCT_MANU_TAG = "ID:LCT-MANU:"

// DB Assessor Roles
export const DB_ASSESSOR_GEN = "DB-ASSESSOR-GEN"
export const DB_ASSESSOR_DEMAND = "DB-ASSESSOR-DEMAND"
export const DB_ASSESSOR_V2G = "DB-ASSESSOR-V2G"

// Sys Admin
export const ENA_SYS_ADMIN = "ENA-SYS-ADMIN"
export const ID_ADMIN_ENA = "ID:ADMIN:ENA"

// General Public
export const PUBLIC = "PUBLIC"

// Other roles
export const AWAITING_SET_UP = "AWAITING-SET-UP"

// Insight roles
export const INSIGHTS_AUTHOR = "INSIGHTS-AUTHOR"
export const INSIGHTS_READER = "INSIGHTS-READER"

// Role for allowing all classes of user access to UI component
export const ALL_ALLOWED = "ALL"

// Several APIs hooks are multi-fetcher. These APIs direct request
// through either the public or protected axios client. To be directed
// to the protected client, a user must be signed in and have a role in
// the below list, else they are directed to the public data.
export const MULTI_FETCH_PROTECTED_ACCESS = [
    DB_ASSESSOR_DEMAND,
    DB_ASSESSOR_GEN,
    DB_ASSESSOR_V2G,
    DNO_APPROVED,
    LCT_MANU_APPROVED,
    ENA_SYS_ADMIN,
]

export const ALL_WITH_ACCOUNTS = [
    INSTALLER,
    INSTALLER_ADMIN,
    DNO_APPROVED,
    DNO_REPORTING,
    DNO_REVIEWER,
    DNO_ADMIN,
    LCT_MANU_ADMIN,
    LCT_MANU_ADMIN,
    DB_ASSESSOR_GEN,
    DB_ASSESSOR_DEMAND,
    DB_ASSESSOR_V2G,
    ENA_SYS_ADMIN,
]

// Dispatcher linking group name to display name
export const DISPLAY_ROLES: Record<string, string> = {
    [INSTALLER]: "Installer",
    [INSTALLER_ADMIN]: "Installer Admin",
    [INSTALLER_APPROVED]: "Installer User",
    [DNO_APPROVED]: "DNO User",
    [DNO_REPORTING]: "DNO Reporting",
    [DNO_REVIEWER]: "Application Reviewer",
    [DNO_ADMIN]: "DNO Admin",
    [DNO_THRESHOLD_MANAGER]: "Threshold Manager",
    [LCT_MANU_APPROVED]: "Manufacturer User",
    [LCT_MANU_ADMIN]: "LCT Manufacturer Admin",
    [DB_ASSESSOR_GEN]: "Generation Asset Assessor",
    [DB_ASSESSOR_DEMAND]: "Demand Asset Assessor",
    [DB_ASSESSOR_V2G]: "V2G Asset Assessor",
    [ENA_SYS_ADMIN]: "ENA System Admin",
    [PUBLIC]: "General Public User",
}
